import LayoutTablet from '@/layouts/tablet/layout-tablet.vue';
import oBlock from '@/objects/o-block/o-block.vue';

export default {
  name: 'PageNotFound',
  components: {
    'layout-tablet': LayoutTablet,
    'o-block': oBlock
  }
};
